import { useCallback, useEffect, useRef, useState } from "react";
import domtoimage from 'dom-to-image';
import ButtonComp from "./common/ButtonComp";
// import WebApp from "@twa-dev/sdk";
import copy_Completed from "@/assets/images/copy_Completed.png"
import share_agent from "@/assets/images/task/share_agent.png"
import share_card from "@/assets/images/task/share_card.png"
import _123 from "@/assets/images/task/123.webp"
import coins from '@/assets/images/coins.png'
import { getUserInfo } from "@/api/url"
import coin from '@/assets/images/coin.png'
import copy from '@/assets/images/copy.png'
import { useTranslation } from "react-i18next";
import PublicDialog from "./PublicDialog";
import { apiGetShareMessageId, getShareRewards, postShareProfile, getShareStatusList } from "@/api/account.js"
import { Toast } from "react-vant";
import GetCoinAnimationDialog from "./GetCoinAnimationDialog";
import { changeIsGate } from "../store/module/tasks";
import { useDispatch } from "react-redux";
import { changeUserInfo } from "../store/module/tabbar";
import { changeShareStatusList } from "../store/module/progress";
import html2canvas from 'html2canvas';
import CardItem from "./CardItem";
import { TwitterShareButton } from "react-share";

interface ShareContentProps {
  code: string
  pageName: string
  shareDialog: boolean
  cardId: string
  setShareDialog: any
  image: any
  teleport?: any
  shareStatus?: any
  bonusPower?: any
  power?: any
  property?: any
  enhanceLevel?: any
  mint_state?: any
  level?: any
  is_nft?: any
  isHero?: any
}
const ShareContent = ({ cardId, pageName, code, teleport, shareDialog, setShareDialog, image, shareStatus,
  bonusPower,
  power,
  property,
  enhanceLevel,
  mint_state,
  level,
  is_nft = false,
  isHero = false
}: ShareContentProps) => {
  const { t } = useTranslation()
  const [isCopy, setIsCopy] = useState(false)
  const [claimPointsDialog, setClaimPointsDialog] = useState(false)
  const [invitation_code] = useState<any>(localStorage.getItem('inviteCode'))
  const [rewardsData, setRewardsData] = useState({})
  const dispatch = useDispatch()
  const address_params = localStorage.getItem('address_params')

  const id: any = localStorage.getItem('userId')
  const handleCopy = async () => {
    let text = pageName == "agents" ? `${import.meta.env.VITE_HREF}/agent/${cardId}` : `${import.meta.env.VITE_HREF}/cards?type=Sale&startapp=${invitation_code}&cardId=${cardId}`
    try {
      await navigator.clipboard.writeText(text);
      setIsCopy(!isCopy)
    } catch (err) {
    }
  };

  const setUserInfo = useCallback(async () => {
    const UserInfo = await getUserInfo(address_params)
    if (UserInfo.code == "0") {
      dispatch(changeUserInfo(UserInfo.data))
    }
  }, [])

  const captureDom = useRef<any>(null)

  const screenCapture = async (el: any) => {
    let toast = Toast.loading({
      message: t("other.loading"),
      forbidClick: true,
      duration: 10000,
    })
    // try {
    //   await html2canvas(captureDom.current).then((canvas: any) => {
    //     canvas.willReadFrequently = true;
    //     postShareProfile(id, canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,', '')).then((result: any) => {
    //     WebApp.shareToStory(result.data, {
    //       text: `${t(`components.homePage.starAIDescription${pageName == 'agents' ? 'Agent' : 'Card'}`)} ${import.meta.env.VITE_SHARE_URL}startapp=${btoa(`invitation_code=${invitation_code}&pageName=${pageName}&Id=${cardId}`)} `
    //     })
    //     setTimeout(async () => {
    //       if (!el.status) {
    //         const rewards = await getShareRewards(code, el.type)
    //         if (rewards.code == 0) {
    //           setRewardsData(rewards.data)
    //           setClaimPointsDialog(true)
    //         }
    //       }
    //     }, 3000)
    //   })
    //   toast.clear()
    //   });
    // } catch {
    //   toast.clear()
    // }

  }



  const getShareStatusListFunc = async () => {
    const { code, data } = await getShareStatusList()
    if (code == '0') {
      let obj: any = {}
      if (Array.isArray(data)) {
        data.forEach((el: any) => {
          obj[el.code] = el.tasks
        })
      }
      dispatch(changeShareStatusList(obj))
    }
  }
  const AudioRef = useRef<any>()
  const getCoinAnimation = (x: any, y: any) => {
    const R = 100; // 扩散半径
    const time = 0.25; //扩散过度时间
    const time2 = 1; // 收集过度时间
    const w = 26; // 金币大小
    const Num = 8 //金币数量

    setlits(x - coinMovementOffset(), y)

    if (AudioRef.current) {
      // AudioRef.current.currentTime = 0;
      AudioRef.current.play()
    }
    const total = document.getElementsByClassName('total_1')[0] // 获取金币最终飞向

    function setlits(X: any, Y: any) {
      var species = document.createElement('div');
      species.className = 'species'
      for (let i = 0; i < Num; i++) {
        var img = document.createElement('img');
        img.className = 'speciesstyle'
        img.style.width = w + 'px',
          img.style.height = w + 'px',
          img.style.left = X + 'px',
          img.style.top = Y + 'px',
          img.style.transform = 'translate(0%, 0%)',
          img.style.transition = `${time}s`
        img.src = coin
        species.appendChild(img);
      }
      document.querySelector("body").appendChild(species)
      setTimeout(() => {
        clickss(X, Y)
      }, 0)
    }
    // 计算金币扩散范围和坐标
    function clickss(X: number, Y: number) {
      const specielist: any = document.getElementsByClassName('speciesstyle')
      const num = specielist.length
      const center = {
        x: X,
        y: Y
      }
      for (let i = 0; i < num; i++) {
        const xz = center.x + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.sin(2 * Math.PI * i / num)
        const yz = center.y + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.cos(2 * Math.PI * i / num)
        specielist[i].style.transform = `translate(${xz - (X + w / 2)}px, ${yz - (Y + w / 2)}px)`
      }
      setTimeout(() => {
        for (let i = 0; i < num; i++) {
          specielist[i].style.transition = `${time2}s`
          specielist[i].style.transform = `translate(0,0)`
          specielist[i].style.left = Math.floor(total?.getBoundingClientRect().x) - coinMovementOffset() + 'px'
          specielist[i].style.top = Math.floor(total?.getBoundingClientRect().y) + 'px'
        }
        // 结束清除蒙层
        setTimeout(() => {
          remove()
        }, (Number(time2) + 0.5) * 500) //飞行时间结束

      }, (Number(time) + 0.5) * 500) //扩散时间结束
    }
    // 清除dom
    function remove() {
      document.getElementsByClassName('species')[0].remove()
    }
    try {
      setUserInfo()
      getShareStatusListFunc()
    } catch (error) {

    }
  }

  const shareMessage = async (type: number, doneType: boolean) => {
    const toast = Toast.loading({
      message: t("other.loading"),
      duration: 10000,
      forbidClick: true

    })
    try {
      if (!doneType) {
        const rewards = await getShareRewards(code, type)
        if (rewards.code == 0) {
          setClaimPointsDialog(true)
          setRewardsData(rewards.data)
        }
        toast.clear()
      } else {
        toast.clear()
      }
    } catch (e) {
      toast.clear()
    }
  }
  const contentDom = () => {
    return (
      <div className='py-10 px-[10px] relative'>
        <div style={{ backgroundImage: `url(${pageName == 'agents' ? share_agent : share_card})`, backgroundSize: '100% 100%' }} ref={captureDom} className=" translate-x-[-25000px] absolute w-[1296px] pt-[90px] pr-[64px] flex justify-end h-[736px] -z-50">
          <div className="w-[376px] h-[564px] rounded-[20px] relative">
            <CardItem
              bonusPower={bonusPower}
              power={power}
              isHero={isHero}
              property={property}
              enhanceLevel={enhanceLevel}
              mint_state={mint_state}
              is_nft={is_nft}
              id={cardId}
              image={image}
              level={level}
              isShare={true}
            >
            </CardItem>
          </div>
        </div>
        <p className='text-[20px] font-bold text-[#333] leading-6 text-center'>
          {pageName == 'agents' ? t("other.address_sharing") : t("other.card_sharing")}
        </p>
        <div
          style={{ background: 'linear-gradient( 135deg, #FFFFFF 100%, #FFFFFF 100%)' }}
          className={`text-[#333333] mt-5 publishInput relative tracking-[1.5px] text-[14px] leading-[18px] w-[100%] h-10 rounded-[10px] p-2 px-[10xp] font-bold`}
        >


          https://app.starai.pro/...
          <img src={!isCopy ? copy : copy_Completed} className={` ${isCopy ? 'w-[20px]' : 'w-4'}  absolute top-3  right-[10px]`} onClick={() => {
            handleCopy()
          }} alt="" />
        </div>
        <div className=' flex mt-10 justify-center w-full'>
          {Array.isArray(shareStatus) &&
            <TwitterShareButton url={' '}
              onClick={() => {
                shareMessage(0, shareStatus[0].status)
              }}
              className=" flex justify-center"
              title={`✨ StarAI, The best AI Agent platform !
🤩 https://t.me/TheStarAIBot/StarAI?startapp=${invitation_code}
🚀 Play StarAI Claim 100USDT！
🏆 Participate in arena PK to earn victory ranking rewards！
🔥 Stake Cards and Agents to accelerate mining and earn ＄SAI profits！
🌐 More details：https://x.com/The_StarAI`}>
              <div className="new_button_shadow relative cursor-pointer flex gap-1 items-center text-[#fff] text-[14px] font-bold justify-center w-[174px] h-[36px]">
                {t("other.twitter_sharing")}
                {!shareStatus[0].status &&
                  <div className='absolute flex items-center justify-center -top-[10px] right-0 rounded-tr-md rounded-bl-md bg-gradient-to-l to-[#EF4444] from-[#E88585] w-[73px] h-[18px]'>
                    <span className='text-white text-xs'>+ 5k</span>
                    <img className='w-4 ml-2' src={coins} alt="" />
                  </div>}
              </div>
            </TwitterShareButton>
          }
        </div>
      </div >
    )
  }
  return (
    <div>
      <PublicDialog teleport={teleport} closeOnClickOverlay={false} width={"320px"} isPadding={false} dialog={shareDialog} setDialog={setShareDialog} content={contentDom()}></PublicDialog>
      <GetCoinAnimationDialog
        dialog={claimPointsDialog}
        point={rewardsData?.rewards}
        getCoinAnimation={getCoinAnimation}
        setDialog={() => {
          dispatch(changeIsGate(""))
          setClaimPointsDialog(false)
        }}>
      </GetCoinAnimationDialog>
    </div>


  )
}
export default ShareContent